import React from 'react';
import styled from 'styled-components';
import backgroundImage from '../assets/backgroundImageHome.png';
import mainImage from '../assets/aboutZigma.svg';

export default function About() {
 return (
  <Container>
   <Wrapper>
    <Header>
     <div className='bg'>
      <img src={backgroundImage} alt='background wallpaper' />
     </div>
     <h2>What We Do</h2>
     <p>
      <i>
       Our proprietary technology segregates and processes Segregated
       Combustible Fractions from landfills across India that are safely
       processed by our trusted partners
      </i>
     </p>
    </Header>
    <div className='imagediv'>
     <Image src={mainImage} />
    </div>
   </Wrapper>
  </Container>
 );
}

const Container = styled.div`
 width: 100%;
 height: auto;
 background-color: #fff;
`;

const Wrapper = styled.div`
 width: 100%;
 margin: 0 auto;
 padding-top: 12rem;
 padding-bottom: 4rem;
 z-index: 2;
 background-color: #fff;
 div {
  background-color: #fff;
 }
 h2 {
  font-size: 3rem;
  font-weight: 700;
  line-height: 4rem;
  text-transform: capitalize;
  color: #98d82f;
 }
 p {
  font-weight: 500;
  font-size: 2rem;
  line-height: 140%;
  text-align: center;
  color: #a3a3a3;
 }
 .imagediv {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(50px);
  border-radius: 20px;
  margin: 4rem 16rem;
  padding: 2rem 0;
 }
`;

const Image = styled.img`
 width: 100%;
 height: auto;
 object-fit: fill;
`;

const Header = styled.div`
 position: relative;
 height: 30rem;
 z-index: 100;
 display: flex;
 align-items: center;
 justify-content: center;
 flex-direction: column;
 padding: 0 8rem;
 gap: 2rem;
 .bg {
  z-index: -100;
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  background-color: #000;
  img {
   opacity: 0.15;
   width: 100%;
   height: 100%;
   object-fit: cover;
  }
 }
`;
